import React, { useEffect, useState }                                                                    from "react";
import { Button, FormGroup, Row } from "reactstrap";
import { set2FA }                                                                                        from "../../actions/general";
import { useForm }                                                                                       from "react-hook-form";
import * as types from "../../types";
import { dispatch } from "../../actions/util";
import messages from "../../util/messages";

const TwoFactorAuth = (props) => {
  const {
    register,
    handleSubmit,
  } = useForm();

  const [twoFactor, setTwoFactor] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem("twoFactor")) {
      try {
        setTwoFactor(JSON.parse(sessionStorage.getItem("twoFactor")));
      } catch (e) {

      }
    }
  }, []);

  return (
    <form
      className={`w-100 ${!props.xs && 'vh-100'}  overflow-auto`}
      onSubmit={handleSubmit((values) => {
        if(values.code.length === 6 ) {
          set2FA(sessionStorage.getItem("usernameLFS"), values.code)
        } else {
          dispatch(types.ADD_ALERT_NOTIFICATION, {message: messages[types.TWO_FACTOR_AUTH_FAILURE_CODE_SIZE], color: 'danger'});
        }
      })}
    >
      {!twoFactor?.twoFactorEnabled ? (
        <div
          className={`mr-0 pt-4 px-5 px-sm-2 pr-sm-5 two-factor-text ${
            props.xs ? "text-light" : "text-dark"
          }`}
        >
          <h3>Two-Factor Authentication (2FA)</h3>
          <h4 className="h6 primary-color">
            Configuring (Google/Microsoft) Authenticator
          </h4>
          <ol style={{fontSize: "14px", fontWeight: "500"}}>
            <li>
              Install (Google or Microsoft) Authenticator (IOS - Android) or
              Authy (IOS - Android).
            </li>
            <li>In the authenticator app, select "+" icon.</li>
            <li>
              Select "Scan a barcode (or QR code)" and use the phone's camera to
              scan this barcode.
            </li>
          </ol>
          <div>
            <div>
              <h4 className="h6 primary-color">Scan QR Code</h4>
              <div className="d-flex justify-content-center">
                <img
                  className="block w-120 h-120 object-contain"
                  src={twoFactor?.setupCode?.qrCodeSetupImageUrl}
                  alt="qrcode url"
                />
              </div>
            </div>
            <div>
              <h4 className="h6 primary-color pt-3">
                Or Enter Code Into Your App
              </h4>
              <p style={{fontSize: "14px", overflowWrap: 'break-word'}}>
                SecretKey: {twoFactor?.setupCode?.manualEntryKey} <br/> (Base64 encoded)
              </p>
            </div>
            <div>
              <h4 className="h6 primary-color">Verify Code</h4>
            </div>
          </div>

          <FormGroup className="col-12 pl-0 login-input-container d-flex justify-content-around">
            {/*<Label>Password</Label>*/}
            <input
              type="text"
              className="login-input"
              placeholder="Authentication Code"
              name="code"
              required
              ref={register}
            />
          </FormGroup>
          <Row className="pl-0 pb-4 justify-content-between m-0" xs="12">
            <Button className="login-button mb-1" color="primary" size="lg">
              Verify
            </Button>
            {" "}
            <Button className="mb-1" color="secondary" size="lg" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              sessionStorage.clear();
              window.location.reload();
            }}>
              Change user
            </Button>
          </Row>
        </div>
      ) : (
        <div
          className={`mr-0 pt-4 px-5 pl-sm-2 pr-sm-4 h-100 two-factor-text d-flex flex-column justify-content-center  ${
            props.xs ? "text-light" : "text-dark"
          }`}
        >
          <h3>Verify Authenticator Code</h3>
          <FormGroup className="pl-0 login-input-container d-flex justify-content-around">
            <input
              type="text"
              className="login-input"
              placeholder="Enter code"
              name="code"
              required
              ref={register}
            />
          </FormGroup>
          <Row className="pl-0 pb-4 justify-content-between m-0" xs="12">
            <Button className="login-button mb-1" color="primary" size="lg">
              Verify
            </Button>
            {" "}
            <Button className="mb-1" color="secondary" size="lg" onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              sessionStorage.clear();
              window.location.reload();
            }}>
              Change user
            </Button>
          </Row>
        </div>
      )}
    </form>
  );
};

export default TwoFactorAuth;
